import React, { useMemo } from "react";
import { JobApplication } from "../../../Entities/job-application.entity";
import { calculateFunnelStages } from "../../../Utils/candidate-analytics.utils";
import {
  TrophyOutlined,
  BarChartOutlined,
  CheckCircleFilled,
  SendOutlined,
  VideoCameraOutlined,
  ScanOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";

interface ApplicationFunnelProps {
  applications: JobApplication[];
}

const ApplicationFunnel: React.FC<ApplicationFunnelProps> = ({
  applications,
}) => {
  const funnelData = useMemo(
    () => calculateFunnelStages(applications),
    [applications],
  );

  const appliedFunnel = funnelData.find(
    (f) => f.name.toLowerCase() === "applied",
  );

  const profileMatchFunnel = funnelData.find(
    (f) => f.name.toLowerCase() === "profile matched",
  );

  const assessmentFunnel = funnelData.find(
    (f) => f.name.toLowerCase() === "assessment passed",
  );

  const interviewFunnel = funnelData.find(
    (f) => f.name.toLowerCase() === "interviewed",
  );

  const hiredFunnel = funnelData.find((f) => f.name.toLowerCase() === "hired");

  const funnelSteps = [
    {
      label: "Applied",
      count: appliedFunnel?.count,
      done: false,
      icon: <SendOutlined />,
    },
    {
      label: "Profile Matched",
      count: profileMatchFunnel?.count,
      done: false,
      icon: <ScanOutlined />,
    },
    {
      label: "Assessment Passed",
      count: assessmentFunnel?.count,
      done: false,
      icon: <FileDoneOutlined />,
    },
    {
      label: "Interviewed",
      count: interviewFunnel?.count,
      done: false,
      icon: <VideoCameraOutlined />,
    },
    {
      label: "Hired",
      count: hiredFunnel?.count,
      done: false,
      icon: <TrophyOutlined />,
    },
  ];

  return (
    <section className="profile__funnel-section">
      <div className="profile__funnel-card">
        <div className="profile__funnel-glow" />
        <h2 className="profile__funnel-title">
          <BarChartOutlined className="profile__funnel-icon" />
          Application Funnel
        </h2>
        <div className="profile__funnel-steps">
          <div className="profile__funnel-line" />
          {funnelSteps.map((step, i) => (
            <div key={i} className="profile__funnel-step">
              <div
                className={`profile__funnel-circle${step.done ? " profile__funnel-circle--done" : " profile__funnel-circle--pending"}`}
              >
                {step.done ? <CheckCircleFilled /> : step.icon}
              </div>
              <div className="profile__funnel-step-info">
                <p
                  className={`profile__funnel-step-label${step.done ? " profile__funnel-step-label--done" : " profile__funnel-step-label--pending"}`}
                >
                  {step.label}
                </p>
                <p
                  className={`profile__funnel-step-count${!step.done ? " profile__funnel-step-count--pending" : ""}`}
                >
                  {step.count}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ApplicationFunnel;
